import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text } from '@redlink/components/atoms';
import { Button } from '@redlink/components/molecules';

export const AuthCustomAction = memo(({ title, subtitle, onPress }) => {
  const { styles } = useStyle();
  return (
    <View style={styles.container}>
      <Text style={styles.titleText}>{title}</Text>
      <Button
        {...{ onPress }}
        style={styles.actionButton}
        variant="link"
        title={subtitle}
      />
    </View>
  );
});

const useStyle = createUseStyle(({ colors, shadow, size }) => ({
  container: {
    flex: 1,
    alignItems: 'flex-start',
  },
  titleText: {
    color: colors.gray23,
  },
  subtitleText: {
    color: colors.blue1,
  },
  actionButton: {
    padding: 0,
  },
}));
